import { render, staticRenderFns } from "./TopSecondHeader.vue?vue&type=template&id=39165b84"
import script from "./TopSecondHeader.vue?vue&type=script&lang=js"
export * from "./TopSecondHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports